let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kNopA")).then(() => parcelRequire('3Dhfb'));